import React from 'react'
import {Component} from 'react'
import VendorCount from '../vendor-count'
import './days.scss'

class Event extends Component {
  render(){
    let event = this.props.event
    return (
      <div className="ww-day__event">
        <span className="timespan"><i className="fa fa-clock-o" />{event.timeSpan}</span>
        <VendorCount count={event.assignedVendors} />
      </div>
    )
  }
}

class Day extends Component {
  render(){
    let first = this.props.events[0]
    let time = first.startTime
    return (
      <div className="ww-day">
        <div className="ww-day__date">
          <span className="ww-day__weekday highlight">{time.getWeekDay()} </span>
          <span className="ww-day__date">{time.getMonth()}/{time.getDate()}</span>:
        </div>
        <div>
          { this.props.events.map( ( event, i ) => { return <Event key={i} event={event} /> } ) }
        </div>
      </div>
    )
  }
}

export default class extends Component {
  render(){
    let dates = this.props.days
    let keys = Object.keys(dates)
    keys = keys.slice( 0, 2 )
    return (
      <div className="ww-days">
        { keys.map( function( k ){
          return <Day key={k} events={dates[k]} />
        }) }
      </div>
    )
  }
}
